
  function updateCartTotal() {
    // Fetch the updated cart data from the Shopify cart API
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        // Update the cart total price in the DOM
        const totalPriceElement = document.querySelector('#cart-total-price');
        totalPriceElement.textContent = Shopify.formatMoney(cart.total_price);
      })
      .catch((error) => {
        console.error('Error fetching cart data:', error);
      });
  }
  ////

  // When the variant is changed (dropdown change event)
  //$(document).ready(function() {
  // $('select[name="id"]').on('change', function() {
  //    updateProductTitle();
  //  });

  // Run the function on page load to account for pre-selected variants
  //  updateProductTitle();
  // });

  //   document.addEventListener('DOMContentLoaded', function () {
  //     // Check if the current URL contains '/collections/all-products'
  //     var currentUrl = window.location.href;
  //     if (currentUrl.indexOf('/collections/all-products/products/') !== -1) {
  //         // Create the new URL by replacing '/collections/all-products'
  //         var newUrl = currentUrl.replace('/collections/all-products', '');

  //         // Redirect to the new URL without '/collections/all-products'
  //         window.location.replace(newUrl);
  //     }
  // });

  /*  document.addEventListener("DOMContentLoaded", function() {
        console.log("loaded");

        // Push a new state to disable the default back navigation
        window.history.pushState(null, document.title, window.location.href);
        console.log("window.history.pushState", window.location.href);

        // Capture the popstate event when back button is pressed
        window.addEventListener('popstate', function(event) {
            console.log("Back button clicked");
            // Automatically navigate to the previous page in history
            window.history.back(); // This will go back to the previous page in the history stack
        });
    });*/
  document.addEventListener('DOMContentLoaded', function () {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (event) {
      const currentUrl = window.location.href;
      if (currentUrl.includes('#')) {
        // console.log("Avoiding back navigation for anchor link:", currentUrl);
        return; // Don't prevent back for anchor links
      }
      window.history.back();
    });
  });

